module.exports = __webpack_public_path__ + "static/assets/d6fcb8f7d1122787171dd831d1263e71.png";